import "./index.scss";
import { Fade, Bounce } from "react-awesome-reveal";

const SectionTestimonial = () => {
  return (
    <>
      <div className="section-testimonial">
        <div className="header" align="center">
          <div className="header-content">
            <Bounce cascade>
              <h1 className="title-text">Testimonial</h1>
            </Bounce>
            <p>
              Register now and join 700+ effective schools who trust<br></br>
              Mygradecard to take care of their school management
            </p>
          </div>
        </div>
        <div className="w3-container">
          <div className="w3-row">
            <div className="w3-half">
              <div className="textDiv">
                <blockquote>
                  With Mygradecard, you always have access to your data and it
                  helps you analyze your data. I recommend Mygradecard to other
                  schools that want to manage their data
                </blockquote>
                <div></div>
              </div>
            </div>
            <div className="w3-half">
              <div className="imgDiv">
                <Fade direction="right" delay={500}>
                  <img
                    src="https://images.unsplash.com/photo-1581726707445-75cbe4efc586?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=876&q=80"
                    className="img"
                    alt=""
                  />
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionTestimonial;
